import React, { useState, useEffect, useContext } from 'react'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import { getApiTargetInfo, getPermitActions, hasAccesPermits } from 'core'
import { Input, Button, Select, DatePicker } from 'antd'
import CommonScreen from 'admin/component/CommonScreen'
import {
  getEdnaErrocodeMapInterface,
  getWindPlantInfo,
  saveEdnaErrocodeMapInterface,
  deleteEdnaErrocodeMapInterface,
  getEnvConfig,
} from 'api/pgads'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { ErrorContext } from 'context'
import R from 'ramda'
import * as ScreenPermissions from 'core/EventActions'

const types = {
  Forced: 'Forced',
  Maintenance: 'Maintenance',
  Planned: 'Planned',
  RUTH: 'RUTH',
}

const EdnaErrorCodeMapHeaders = [
  dateCol({
    ident: 'effectivedate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'type',
    display: 'Type',
    isKey: true,
    ...toSelectionColProps(types),
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'errorCodes',
    display: 'Error Codes',
    isKey: false,
    width: 350,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]

const modifyTask = apiTargetInfo => data =>
  saveEdnaErrocodeMapInterface(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteEdnaErrocodeMapInterface(apiTargetInfo)(data)

const title = 'BSGF/GHWP Error Code  Map'

const BSGErrorCodeMap = ({
  apiTargetInfo,
  envConfig,
  actionPermits,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const { setError } = useContext(ErrorContext)

  const [plant, setPlant] = useState({})

  useEffect(
    _ => {
      getWindPlantInfo(apiTargetInfo).fork(setError, d => {
        const plantMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          d.map(s => ({ [s.plantIdName]: s.plantIdName }))
        )
        setPlant(plantMap)
      })
    },
    [apiTargetInfo, setError]
  )
  const writePermision = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.REPORT_PERFORMANCE_MEASURES_ADMIN],
    matchAny: true,
  })

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '150px 150px 100px 200px  100px 150px 100px 150px',
          gridGap: '10px',
        }}
      >
        <div
          style={{
            display: 'grid',
            alignContent: 'center',
            justifyContent: 'end',
          }}
        >
          Effective Date :{' '}
        </div>

        <DatePicker
          value={insertData.effectivedatemoment}
          onChange={date =>
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedatemoment: date,
            })
          }
          allowClear={false}
          format="MM/DD/YYYY"
        />

        <div
          style={{
            display: 'grid',
            alignContent: 'center',
            justifyContent: 'end',
          }}
        >
          Plant :{' '}
        </div>

        <Select
          value={insertData.plantId}
          onChange={plantId => setInsertData({ ...insertData, plantId })}
          style={{ gridColumn: 'span 3' }}
        >
          {Object.keys(plant).map(k => (
            <Select.Option value={k} key={k}>
              {k}
            </Select.Option>
          ))}
        </Select>

        <div
          style={{
            display: 'grid',
            alignContent: 'center',
            justifyContent: 'end',
          }}
        >
          Type :{' '}
        </div>

        <Select
          value={insertData.type}
          onChange={type => setInsertData({ ...insertData, type })}
          // style={{ gridColumn: 'span 3' }}
        >
          {Object.keys(types).map(k => (
            <Select.Option value={k} key={k}>
              {k}
            </Select.Option>
          ))}
        </Select>

        <div
          style={{
            display: 'grid',
            alignContent: 'center',
            justifyContent: 'end',
          }}
        >
          Error Codes :{' '}
        </div>
        <Input
          style={{ gridColumn: 'span 3' }}
          value={insertData.errorCodes}
          onChange={e =>
            setInsertData({ ...insertData, errorCodes: e.target.value })
          }
        />

        <div />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>

        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      isAdminScreen={false}
      title={title}
      header={EdnaErrorCodeMapHeaders}
      saveTask={modifyTask}
      retrieveTask={getEdnaErrocodeMapInterface}
      deleteTask={deleteTask}
      altBy={d => d.turbine}
      autoRetrieve
      sortOptions={EdnaErrorCodeMapHeaders}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      // widthOffset={150}
      withoutModify={!writePermision}
      allowInsert={writePermision}
      insertComp={writePermision && insertEvent && insertComp}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(BSGErrorCodeMap)
